import { FC } from 'react';
import { FinderResultContentStoryblok } from 'storyblok-types';
import { components } from 'pages/StoryBlok/component';
import { IServerProps } from 'pages/StoryBlok/types';

export const FinderResults: FC<{
  blok: FinderResultContentStoryblok;
  serverProps?: IServerProps;
}> = ({ blok, serverProps }) => {
  return (
    <>
      {blok.content?.map((nestedBlok) => {
        const Component = components[nestedBlok.component] as any;
        return !Component ? null : (
          <Component
            key={nestedBlok._uid}
            blok={nestedBlok}
            serverProps={serverProps}
          />
        );
      })}
    </>
  );
};
